// Helpers barrel export

export {
  isAndroidDevice,
  isIOSDevice,
  isMobileWeb,
  getPlatformType,
  checkIfAppInstalled,
  clearAppInstallCache,
  isBannerDismissed,
  dismissBanner,
} from './appDetection';

export {
  loadAppsFlyerSmartScript,
  isSmartScriptReady,
  generateOneLinkURL,
  generateFallbackOneLinkURL,
  initAndGenerateOneLinkURL,
} from './appsFlyerSmartScript';

/**
 * Derive page type from the current URL pathname
 * Used by app migration banners to pass correct page_type to AppsFlyer
 */
export const getPageType = (pathname: string): string => {
  if (pathname === '/') return 'home';
  if (/\/p\//.test(pathname)) return 'pdp';
  if (/\/catalogsearch\/result/.test(pathname)) return 'plp';
  if (/\/c\//.test(pathname)) return 'plp';
  if (/\/lp\//.test(pathname)) return 'landing';
  if (/\/wishlist/.test(pathname)) return 'wishlist';
  if (/\/v2\/checkout/.test(pathname)) return 'checkout';

  return 'other';
};

/**
 * Navigate to a URL in a way that allows the OS to intercept and open
 * the installed native app (Android App Links / iOS Universal Links).
 *
 * `window.location.href = url` is a script-initiated navigation that
 * both Android and iOS treat as a plain web request, bypassing the
 * app-link resolution layer — so the user always lands on the web
 * fallback (Play Store / App Store) even when the app is installed.
 *
 * `window.open(url, '_self')` triggered inside a synchronous user-gesture
 * call-chain is treated as a user-initiated navigation on both platforms,
 * allowing the OS to check registered App Links / Universal Links and
 * open the app when it is installed.
 */
export const navigateToURL = (url: string): void => {
  if (typeof window === 'undefined' || !url) return;

  window.open(url, '_self');
};
